import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaMaxInclusiveFacet extends XmlSchemaFacet {}
